<template>
    <div>
        <div ref="htmlContainer" v-if="loaded"></div>
    </div>
</template>

<script>
import axios from 'axios';
export default{
    name:"Qwen-Vid_Chat",
    data() {
    return {
      loaded: false,
      htmlContent: ''
    };
  },
  async mounted() {
    try {
      const response = await axios.get('', { responseType: 'text' });
      this.htmlContent = response.data;
      this.loaded = true;
    } catch (error) {
      console.error('Failed to load HTML content:', error);
    }
  },
  updated() {
    if (this.loaded) {
      this.$refs.htmlContainer.innerHTML = this.htmlContent;
    }
  }


}




</script>

<style>

</style>